import { SessionResultInterface } from '@/webcomponents/f1-season/store/interface/event';
import TeamResponseInterface from '@/webcomponents/f1-season/store/interface/team';
import DriverResponseInterface from '@/webcomponents/f1-season/store/interface/driver';

const BEHIND_KEYWORDS = ['x', 'dnf', '-'];

export function keywordsInBehind (behind: string) {
  const toLower = behind.toLowerCase();
  let hasKeywords = false;
  BEHIND_KEYWORDS.forEach((keyword) => {
    hasKeywords = hasKeywords || toLower.indexOf(keyword) !== -1;
  });
  return hasKeywords;
}

export function sortByLabs (val1: SessionResultInterface, val2: SessionResultInterface) {
  const sameOrMoreLaps = Number(val1.laps) >= Number(val2.laps);
  const betterTime = val1.time <= val2.time;
  if (sameOrMoreLaps && betterTime) {
    return -1;
  }
  return Number(val2.laps) - Number(val1.laps);
}

export function sortByOther (val1: SessionResultInterface, val2: SessionResultInterface) {
  const val1Check = val1.time === '' || keywordsInBehind(val1.behind);
  const val2Check = val2.time === '' || keywordsInBehind(val2.behind);
  if (val1Check && val2Check) {
    return Number(val2.laps) - Number(val1.laps);
  }
  return val1Check ? 1 : -1;
}

export function sortRaceResults (array: Array<SessionResultInterface>, ignoreLaps = false) {
  return array.sort((val1, val2) => {
    const val1Check = val1.time !== '' && !keywordsInBehind(val1.behind);
    const val2Check = val2.time !== '' && !keywordsInBehind(val2.behind);
    if (val1Check && val2Check) {
      if (ignoreLaps) {
        return val1.time <= val2.time ? -1 : 1;
      }
      return sortByLabs(val1, val2);
    }
    // eg. disqualified
    return sortByOther(val1, val2);
  });
}

export function sortByPointOrPosition (val1: TeamResponseInterface | DriverResponseInterface, val2: TeamResponseInterface | DriverResponseInterface) {
  if (val1.points === val2.points) {
    return Number(val1.position) - Number(val2.position);
  }
  return val2.points - val1.points;
}

export default {
  sortRaceResults,
  keywordsInBehind,
  sortByPointOrPosition,
};
